import React from 'react';
import { createPortal } from 'react-dom';
import HiddenForm from '../HiddenForm';
import SuggestPageUpdateModal from '../page/SuggestPageUpdateModal';
import {
    getEditPageUrlFromSlug,
    getPageUrlFromSlug,
} from '../../utilities/urlHelper';
import ChangePageOwner from '../page/ChangePageOwner';
import LinkMenu from '../share/LinkMenu';
import VerificationScheduleWrapper from '../page/VerificationScheduleWrapper';
import { canVerifyPage } from '../../utilities/permissionsUtilities';

class AnalyticsPageDropDown extends React.Component {
    state = {
        showSuggestUpdateModal: false,
        showPageAuthModal: false,
    };

    onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            this.setState({ showPageAuthModal: false });
        }
    };

    render() {
        const { page } = this.props;
        const { slug } = page;
        const { showSuggestUpdateModal, showPageAuthModal } = this.state;

        return (
            <div className="dropdown dropdown-right-aligned right">
                <button className="page-list-dropdown dropdown-link">
                    <img className="button-icon" src="/img/icons/dropdown-elipsis.svg" />
                </button>
                <div className="dropdown-overlay" style={{ display: 'none' }} />
                <div className="dropdown-content no-select" style={{ display: 'none' }}>
                    <a href={getPageUrlFromSlug(slug)} className="link dropdown-option">View page</a>
                    {(this.props.canVerify || canVerifyPage())
                        && <span className="link dropdown-option" onClick={this.props.verify}>Verify page</span>}
                    <VerificationScheduleWrapper page={page} verifiedPage />
                    {this.props.markAsFresh
                        && <span className="link dropdown-option" onClick={this.props.markAsFresh}>Mark as fresh</span>}
                    {this.props.includeChangeOwner
                        && <ChangePageOwner pageId={page.id} onOwnerAssigned={this.props.onOwnerAssigned} />}
                    {this.props.authToken && this.props.authTokenId
                        && <span className="link dropdown-option" onClick={() => this.setState({ showPageAuthModal: true })}>View shareable public link</span>}
                    <a className="dropdown-option do-cancel">Cancel</a>
                </div>
                {showSuggestUpdateModal && createPortal(<SuggestPageUpdateModal page={page} closeModal={() => this.setState({ showSuggestUpdateModal: false })} />, document.body)}
                {showPageAuthModal
                    && createPortal(
                        <div className="react-modal open" onMouseDown={this.onClickModal}>
                            <div className="modal-content p2">
                                <LinkMenu
                                    slug={slug}
                                    pageId={page.id}
                                    authToken={this.props.authToken}
                                    authTokenId={this.props.authTokenId}
                                    closeModal={() => this.setState({ showPageAuthModal: false })}
                                    onShareDisabled={this.props.onShareDisabled}
                                />
                            </div>
                        </div>,
                        document.body,
                    )}
            </div>
        );
    }
}

export default AnalyticsPageDropDown;
